module.exports = __webpack_public_path__ + "static/img/steppy.b95bf59.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/steppy.png
// module id = yeo4
// module chunks = 1